var map = {
	"./ar.json": "af08",
	"./cn.json": "f4a5",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./pt.json": "5d67",
	"./ru.json": "7704",
	"./th.json": "8680"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";